import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "preview"]

  validateStep(event) {
    const requiredFields = this.fieldTargets.filter(field => field.required)
    let isValid = true

    requiredFields.forEach(field => {
      if (!field.value.trim()) {
        field.classList.add("border-red-500")
        isValid = false
      } else {
        field.classList.remove("border-red-500")
      }
    })

    if (!isValid) {
      event.preventDefault()
    }
  }

  updatePreview() {
    if (this.hasPreviewTarget) {
      this.previewTarget.setAttribute("aria-live", "polite")
      this.previewTarget.classList.add("animate-pulse")
      setTimeout(() => {
        this.previewTarget.classList.remove("animate-pulse")
      }, 300)
    }
  }
}
